import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logoNavy from '../../assets/logo-navy.png';

export function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await resetPassword(email);
    if (error) setError(error.message);
    else setSent(true);
    setLoading(false);
  }

  if (sent) {
    return (
      <div className="auth-screen" style={{ alignItems: 'center', justifyContent: 'center' }}>
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div className="auth-success-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h2 className="auth-title">Email sent</h2>
          <p className="auth-subtitle" style={{ marginTop: 8 }}>
            Check <strong>{email}</strong> for a password reset link.
          </p>
          <Link to="/login" className="auth-link-primary" style={{ display: 'inline-block', marginTop: 24 }}>
            Back to Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-screen" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <div className="auth-panel-right" style={{ maxWidth: 480 }}>
        <div className="auth-card">
          <div className="auth-logo">
            <img src={logoNavy} alt="Apex Elite" style={{ height: 40 }} />
          </div>
          <h1 className="auth-title">Reset password</h1>
          <p className="auth-subtitle">We'll send a reset link to your email.</p>

          <form className="form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>
            {error && <p className="form-error">{error}</p>}
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="auth-links" style={{ justifyContent: 'center' }}>
            <Link to="/login" className="auth-link">Back to Sign In</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
